// firebase.config.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCh6E5Y2LBNQC9xjUTyzLHiuP8Cw3ZsknY",
  authDomain: "aifactory-355af.firebaseapp.com",
  projectId: "aifactory-355af",
  storageBucket: "aifactory-355af.firebasestorage.app",
  messagingSenderId: "563985146675",
  appId: "1:563985146675:web:0debbbe60cd5992b4e1446",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// Task status constants
export const TASK_STATUS = {
  NOT_STARTED_L1: "NOT_STARTED_L1",
  COMPLETED_L1: "COMPLETED_L1",
  PENDING_QA_L1: "PENDING_QA_L1",
  VALIDATED_L1: "VALIDATED_L1",
  TO_BE_REWORKED_L1: "TO_BE_REWORKED_L1",
  NOT_STARTED_L2: "NOT_STARTED_L2",
  COMPLETED_L2: "COMPLETED_L2",
  PENDING_QA_L2: "PENDING_QA_L2",
  VALIDATED_L2: "VALIDATED_L2",
  TO_BE_REWORKED_L2: "TO_BE_REWORKED_L2",
  GENERATED: "GENERATED",
};